import { render, staticRenderFns } from "./GrupoDeAcessoForm.vue?vue&type=template&id=e1b046dc&scoped=true&lang=pug&"
import script from "./GrupoDeAcessoForm.vue?vue&type=script&lang=js&"
export * from "./GrupoDeAcessoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1b046dc",
  null
  
)

export default component.exports